<div class="table-container m-t-12">
  @if ((getUsersApiCallStatus === 'COMPLETED_SUCCESFULLY' && data.length > 0) || getUsersApiCallStatus === 'IN_PROGRESS') {
    <mc-table
      data-cy="work-order-list"
      [data]="data.length === 0 ? mockDataForLoadingAnimation : data"
      fit="small"
      [columns]="columns"
      nowrap="true"
      sortmanual
      sortdefaultdirection="descending"
      (sortchange)="onSortDirectionChange($event)"
      tabularFigures="true"
      headersticky
      height="100%">
      <!-- Real data rows -->
      @for (row of data; track row) {
        <div slot="{{ row.userId }}_username">
          @if (getUsersApiCallStatus === 'IN_PROGRESS') {
            <app-loader></app-loader>
          } @else {
            <a [routerLink]="['/users', row.userId]" [queryParams]="{ tab: activeUserTab === 0 ? 'shop-user' : 'non-shop-user' }">
              {{ row.username }}
            </a>
          }
        </div>
        <div slot="{{ row.userId }}_role">
          <app-overflow-list [items]="row.rolesList" [useTags]="true"></app-overflow-list>
        </div>
        <div slot="{{ row.userId }}_shopCode">
          <app-overflow-list [items]="row.shopCodes" [useTags]="true"></app-overflow-list>
        </div>
        <div slot="{{ row.userId }}_region">
          <app-overflow-list [items]="row.regionsList" [useTags]="true"></app-overflow-list>
        </div>
        <div slot="{{ row.userId }}_cluster">
          <app-overflow-list [items]="row.clustersList" [useTags]="true"></app-overflow-list>
        </div>
        <div slot="{{ row.userId }}_isActive">
          @if (getUsersApiCallStatus === 'IN_PROGRESS') {
            <app-loader></app-loader>
          } @else {
            <mc-tag fit="small" [appearance]="row.isActive ? 'info' : 'neutral'" [label]="row.isActive ? 'Active' : 'Inactive'"></mc-tag>
          }
        </div>
        <div slot="{{ row.userId }}_actions" class="action-icon">
          @if (getUsersApiCallStatus === 'IN_PROGRESS') {
            <app-loader></app-loader>
          } @else if (authPolicy.canAddEditUsers) {
            <mc-button
              padding="compact"
              fit="small"
              hiddenlabel
              icon="pencil"
              appearance="primary"
              variant="plain"
              [routerLink]="['/users/edit', row.userId]">
            </mc-button>

            <mc-button
              padding="compact"
              fit="small"
              hiddenlabel
              icon="trash"
              appearance="primary"
              variant="plain"
              (click)="showDeleteModalDialog(row)"
              (keydown)="showDeleteModalDialog(row)">
            </mc-button>
          }
        </div>
      }
      <!-- Initial load skeleton: only rendered when no real data is present -->
      @if (data.length === 0) {
        @for (row of mockDataForLoadingAnimation; track row.id) {
          @for (col of columns; track col.id) {
            <div slot="{{ row.id }}_{{ col.id }}"><app-loader></app-loader></div>
          }
        }
      }
    </mc-table>
  } @else {
    <div class="pure-g">
      <div class="pure-u-md-24-24 pure-u-lg-24-24 pure-u-xl-24-24 m-t-204 flex-container flex-center no-data">
        <span i18n>No Data Found</span>
      </div>
      <div class="pure-u-md-24-24 pure-u-lg-24-24 pure-u-xl-24-24 m-t-36 flex-container flex-center">
        <span i18n>To widen your search, change or remove filters.</span>
      </div>
    </div>
  }
</div>
<div class="pure-g m-t-16 footer">
  <div class="pure-u-md-6-24 pure-u-lg-4-24 pure-u-xl-4-24">
    <mc-select
      style="width: 140px; display: block"
      [value]="pageLimit"
      optionswidth="100px"
      ngDefaultControl
      label="Per page"
      labelposition="left"
      fit="small"
      (optionselected)="onPageLimitChange($event)">
      @for (pageCount of [10, 20, 50, 100, 200]; track $index) {
        <mc-option [value]="pageCount">{{ pageCount }}</mc-option>
      }
    </mc-select>
  </div>

  <div class="pure-u-md-12-24 pure-u-lg-16-24 pure-u-xl-16-24 flex-container flex-center">
    @if (lastPage && lastPage > 1) {
      <mc-pagination
        hiddenlabels
        [currentpage]="currentPage"
        [totalpages]="lastPage || 1"
        visiblepages="7"
        (pagechange)="onPageChange($event)"
        fit="small">
      </mc-pagination>
    }
  </div>

  <div class="pure-u-md-6-24 pure-u-lg-4-24 pure-u-xl-4-24 text-align-right">
    @if (totalItemCount) {
      <span class="page-description" i18n
        >Showing {{ getUsersApiCallStatus === 'IN_PROGRESS' ? '...' : data.length }} of {{ totalItemCount }}</span
      >
    }
  </div>
</div>
<mc-modal
  hiddenclose
  backdropcloseactiondisabled
  heading="Delete user"
  fit="small"
  dimension="small"
  [open]="openDeleteDialog"
  (closed)="onDeleteUserConfirmationClosed()">
  @if (deleteApiCallStatus === 'NOT_STARTED') {
    <p style="font-size: 0.8rem">The user will be deleted permanently. Are you sure you want to delete?</p>
  }
  @if (deleteApiCallStatus === 'IN_PROGRESS') {
    <p style="font-size: 0.8rem">Deleting user...</p>
  }
  @if (deleteApiCallStatus === 'COMPLETED_SUCCESFULLY') {
    <p>User deleted !</p>
    <p>Taking you back to list page..</p>
  }
  @if (deleteApiCallStatus !== 'COMPLETED_SUCCESFULLY') {
    @if (deleteApiCallStatus !== 'IN_PROGRESS') {
      <mc-button
        slot="secondaryAction"
        dialogaction="cancel"
        appearance="neutral"
        variant="outlined"
        (click)="onDeleteUserConfirmationClosed()"
        (keydown.enter)="onDeleteUserConfirmationClosed()"
        (keydown.space)="$event.preventDefault(); onDeleteUserConfirmationClosed()"
        tabindex="0"
        >Cancel</mc-button
      >
    }
    <mc-button
      slot="primaryAction"
      appearance="primary"
      [loading]="deleteApiCallStatus === 'IN_PROGRESS'"
      (click)="onDeleteUserConfirmed(selectedRowData)"
      (keydown.enter)="onDeleteUserConfirmed(selectedRowData)"
      (keydown.space)="$event.preventDefault(); onDeleteUserConfirmed(selectedRowData)"
      tabindex="0"
      >Yes</mc-button
    >
  }
</mc-modal>
